import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Come ricevo il materiale?',
  a: 'Immediatamente dopo il pagamento ricevi un link per scaricare tutti i PDF. Accesso immediato, nessuna attesa. Puoi usarli già dalla prossima lezione.'
}, {
  q: 'Funziona sia per le Medie che per le Superiori?',
  a: 'Assolutamente sì. I Tomi 1-2 coprono le competenze base per la Scuola Media, i Tomi 3-6 approfondiscono il canone letterario per Licei e Istituti. Ogni sezione indica il livello target.'
}, {
  q: 'Cosa succede se ho studenti con BES o DSA?',
  a: "Il Bonus 1 è interamente dedicato all'inclusione con materiali compensatori, mappe e PDP template pronti. Ogni tomo include attività differenziate per livello."
}, {
  q: 'È allineato ai programmi del MIM?',
  a: "Sì. Tutti i contenuti seguono le Indicazioni Nazionali, il PECUP, le linee guida per l'Educazione Civica e i quadri di riferimento per l'Esame di Stato 2025-2026."
}, {
  q: 'I materiali sono editabili?',
  a: 'Sì. Ricevi i file ottimizzati per Gamma App e i modelli pronti da personalizzare con i dati della tua classe e il tuo nome.'
}, {
  q: 'Per quanto tempo ho accesso?',
  a: 'A vita. Paghi una volta sola e i materiali sono tuoi per sempre, inclusi tutti gli aggiornamenti futuri.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-14 px-4 bg-brand-dark" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-12 uppercase text-brand-cream" data-id="element-81">
          Domande Frequenti
        </motion.h2>

        <div className="space-y-4" data-id="element-82">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-brand-card border border-white/10 rounded-xl overflow-hidden" data-id="element-83">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-white/5 transition-colors" data-id="element-84">
                <span className="font-bold text-brand-cream pr-4" data-id="element-85">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-orange transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-86" />
              </button>

              <AnimatePresence data-id="element-87">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-88">
                    <div className="px-6 pb-5 pt-0 text-gray-400 font-medium leading-relaxed" data-id="element-89">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}